<div>
    <div class="modal-header bg-primary text-white">
      <h4 class="modal-title">{{title}}</h4>
    </div>
    <div class="modal-body">
      <div class="{{messageClass}}" role="alert">{{message}}<BR><a *ngIf="messageUrl" href="{{messageUrl}}" target="_blank" rel="noopener">{{messageUrlTitle}}</a></div>
    </div>
    <div class="modal-footer">
      <button type="button"
        class="btn btn-primary mr-2"
        (click)="activeModal.close(true)">OK</button>
    </div>
</div>